import React from 'react';

interface Props { investorName: string; }

export const Slide1Welcome: React.FC<Props> = ({ investorName }) => (
  <div className="bs-slide-inner">
    {/* Atmospheric globe orb background */}
    <div className="bs-slide-bg bs-slide-bg--globe" aria-hidden="true">
      <div className="bs-globe-orb" />
      <div className="bs-globe-ring bs-globe-ring--1" />
      <div className="bs-globe-ring bs-globe-ring--2" />
      <div className="bs-stars" />
      <div className="bs-overlay" />
    </div>

    <div className="bs-content">
      {/* NM monogram */}
      <div className="bs-logo" aria-hidden="true">
        <span className="bs-logo-n">N</span>
        <span className="bs-logo-m">M</span>
      </div>
      <h1 className="bs-headline">
        Welcome aboard, {investorName}.
      </h1>
      <p className="bs-subline">
        The world is bigger than most people imagine.
      </p>
    </div>
  </div>
);
